import axios from 'axios';
import { getServerCore, defaultSnackbarTimeout } from '../../../utils';
import { showSuccessSnackbar } from '../Snackbar/snackbar.action';

const { serverUrls } = getServerCore();
const authUrl = serverUrls.getAuthUrl()

export const StakeMap = {
    GET_CURRENT_SLOT_START: 'GET_CURRENT_SLOT_START',
    GET_CURRENT_SLOT_SUCCESS: 'GET_CURRENT_SLOT_SUCCESS',
    GET_CURRENT_SLOT_ERROR: 'GET_CURRENT_SLOT_ERROR',

    GET_GRAM_PRICE_START: 'GET_GRAM_PRICE_START',
    GET_GRAM_PRICE_SUCCESS: 'GET_GRAM_PRICE_SUCCESS',
    GET_GRAM_PRICE_ERROR: 'GET_GRAM_PRICE_ERROR',

    PURCHASE_GOLD_START: 'PURCHASE_GOLD_START',
    PURCHASE_GOLD_SUCCESS: 'PURCHASE_GOLD_SUCCESS',
    PURCHASE_GOLD_ERROR: 'PURCHASE_GOLD_ERROR',

    GET_ALL_PURCHASE_GOLD_ORDER_BYID_START: 'GET_ALL_PURCHASE_GOLD_ORDER_BYID_START',
    GET_ALL_PURCHASE_GOLD_ORDER_BYID_SUCCESS: 'GET_ALL_PURCHASE_GOLD_ORDER_BYID_SUCCESS',
    GET_ALL_PURCHASE_GOLD_ORDER_BYID_ERROR: 'GET_ALL_PURCHASE_GOLD_ORDER_BYID_ERROR',

    GET_USER_PURCHASE_HISTORY_START: 'GET_USER_PURCHASE_HISTORY_START',
    GET_USER_PURCHASE_HISTORY_SUCCESS: 'GET_USER_PURCHASE_HISTORY_SUCCESS',
    GET_USER_PURCHASE_HISTORY_ERROR: 'GET_USER_PURCHASE_HISTORY_ERROR',

    SET_WITHDRAW_REQUEST_START: 'SET_WITHDRAW_REQUEST_START',
    SET_WITHDRAW_REQUEST_SUCCESS: 'SET_WITHDRAW_REQUEST_SUCCESS',
    SET_WITHDRAW_REQUEST_ERROR: 'SET_WITHDRAW_REQUEST_ERROR',

    GET_WITHDRAW_LIST_START: 'GET_WITHDRAW_LIST_START',
    GET_WITHDRAW_LIST_SUCCESS: 'GET_WITHDRAW_LIST_SUCCESS',
    GET_WITHDRAW_LIST_ERROR: 'GET_WITHDRAW_LIST_ERROR',

    SET_ORDER_BATCH_NUMBER: 'SET_ORDER_BATCH_NUMBER',
    SET_WITHDRAW_BATCH_NUMBER: 'SET_WITHDRAW_BATCH_NUMBER',

    RESET_TRANSACTION_DETAILS_DATA: 'RESET_TRANSACTION_DETAILS_DATA',

    GET_WITHDRAW_SETTINGS_START: 'GET_WITHDRAW_SETTINGS_START',
    GET_WITHDRAW_SETTINGS_SUCCESS: 'GET_WITHDRAW_SETTINGS_SUCCESS',
    GET_WITHDRAW_SETTINGS_ERROR: 'GET_WITHDRAW_SETTINGS_ERROR',
}

export const setOrderBatchNumber = (data) => ({ type: StakeMap.SET_ORDER_BATCH_NUMBER, payload: data });
export const setWithdrawBatchNumber = (data) => ({ type: StakeMap.SET_WITHDRAW_BATCH_NUMBER, payload: data });
export const resetTransactionDetails = () => ({ type: StakeMap.RESET_TRANSACTION_DETAILS_DATA });

export const getCurrentSlotAsync = (ercContract, address, cb) => async (dispatch, getState) => {
    try {
        dispatch({ type: StakeMap.GET_CURRENT_SLOT_START });
        let { _id } = getState().auth.user;
        let currentSlot = await ercContract.methods
            .getHistoryOfMintedGold()
            .call({ from: address });

        let getAllPurchaseHistoryResult = await ercContract.methods
            .getAllPurchaseHistory()
            .call({ from: address })

        const { data } = await axios({
            method: "GET",
            url: `${authUrl}/getAllPurchaseGoldOrder/${_id}`,
        });
        console.log(data)
        console.log(currentSlot)
        console.log(getAllPurchaseHistoryResult)
        currentSlot = currentSlot[currentSlot.length - 1];
        let finalData = {};
        let incGram = 0.000000003725, currentToken = 0.001;
        let totalTokensUsed = 0
        getAllPurchaseHistoryResult.forEach(history => {
            let goldGram = history.goldPartID;
            let tokenValue = parseInt(history.tokenValue);
            totalTokensUsed += tokenValue;
            let gramsUsed = finalData[goldGram] ? finalData[goldGram].gramsUsed : 0
            for (let i = 0; i < tokenValue; i++) {
                gramsUsed = gramsUsed + currentToken;
                currentToken = currentToken + incGram;
            }
            if (finalData[goldGram]) {
                finalData[goldGram] = {
                    tokens: finalData[goldGram].tokens + parseInt(history.tokenValue),
                    gramsUsed: gramsUsed,
                    goldPartID: history.goldPartID
                }
            } else {
                finalData[goldGram] = {
                    tokens: parseInt(history.tokenValue),
                    gramsUsed: gramsUsed,
                    goldPartID: history.goldPartID
                }
            }
        })
        if (typeof cb === "function") {
            cb();
        }
        let saved = {}, orderHistory = [];
        if (currentSlot) {
            if (data.responseCode === 200) {
                orderHistory = data.responseData || [];
            }
            let order = orderHistory.filter(or => or.goldPartID === currentSlot.id && or.status === "ACCEPTED");
            let transactions = {};
            order.forEach((or) => {
                let user = or.userDetails;
                if (transactions[user._id]) {
                    transactions[user._id].grams += parseFloat(or.grams);

                } else {
                    transactions[user._id] = {
                        grams: parseFloat(or.grams),
                        user,
                    }
                }
            })
            let userPercent = [], totalPercent = 0;
            for (let key in transactions) {
                let percent = {
                    ...transactions[key].user,
                    percent: (transactions[key].grams * 100) / parseFloat(currentSlot.Gram)
                }
                totalPercent = percent.percent + totalPercent;
                userPercent.push(percent)
            }
            saved = {
                Gram: currentSlot.Gram,
                tokens: finalData[currentSlot.id] ? finalData[currentSlot.id].tokens : '0',
                gramsUsed: finalData[currentSlot.id] ? finalData[currentSlot.id].gramsUsed : '0',
                currentToken: currentToken,
                totalTokensUsed: totalTokensUsed,
                goldPartID: currentSlot.id,
            }
            saved.availableGold = parseFloat(saved.Gram) - parseFloat(saved.gramsUsed);
            saved.orders = order;
            saved.percent = userPercent;
            saved.totalPercent = totalPercent;

        }
        console.log(saved);
        dispatch({ type: StakeMap.GET_CURRENT_SLOT_SUCCESS, payload: saved });
    } catch (error) {
        console.log(error);
        dispatch({ type: StakeMap.GET_CURRENT_SLOT_ERROR });
        dispatch(showSuccessSnackbar('error', "Error while getting current slot.", 3000));
    }
}

export const getUserPurchaseHistoryAsync = (ercContract, address, web3, batch, limit, status) => async (dispatch, getState) => {
    try {
        dispatch({ type: StakeMap.GET_USER_PURCHASE_HISTORY_START });
        let { _id } = getState().auth.user;
        let balanceResult = await ercContract.methods
            .balanceOf(address)
            .call({ from: address });

        let userOrderHistoryResult = await ercContract.methods
            .getUserOrderHistory(address)
            .call({ from: address })
        const { data } = await axios({
            method: 'POST',
            url: `${authUrl}/getAllWithdraw/${_id}/${batch}/${limit}`,
            data: { status }
        })
        if (data.responseCode !== 200) {
            dispatch({ type: StakeMap.GET_USER_PURCHASE_HISTORY_ERROR });
            return dispatch(showSuccessSnackbar('error', "Error while getting purchase history.", 3000));
        }
        console.log(userOrderHistoryResult)
        console.log(balanceResult);
        let finalData = {
            slots: [],
            totalBalance: balanceResult,
            withdrawList: data.responseData[0].list,
            totalRecords: data.responseData[0].total.length ? data.responseData[0].total[0].count : 0
        }
        userOrderHistoryResult.forEach(rs => {
            let grams = web3.utils.hexToNumberString(rs.gram)
            grams = parseFloat(grams) / 1e18;
            let tokens = parseInt(rs.tokenValue) / 1e18;
            finalData.slots.push({
                ...rs,
                tokens,
                grams
            })
        })
        console.log(finalData)
        dispatch({ type: StakeMap.GET_USER_PURCHASE_HISTORY_SUCCESS, payload: finalData });
    } catch (error) {
        console.log(error);
        dispatch({ type: StakeMap.GET_USER_PURCHASE_HISTORY_ERROR });
        dispatch(showSuccessSnackbar('error', "Error while getting purchase history.", 3000));
    }
}

export const getBaseGramPriceAsync = () => {
    return async (dispatch, getState) => {
        try {
            let { _id } = getState().auth.user;
            dispatch({ type: StakeMap.GET_GRAM_PRICE_START });
            const { data } = await axios({
                method: "GET",
                url: `${authUrl}/getPurchasePriceInc/${_id}`,
            });
            console.log(data);
            if (data.responseCode === 200) {
                return dispatch({ type: StakeMap.GET_GRAM_PRICE_SUCCESS, payload: data.responseData });
                // return dispatch(showSuccessSnackbar('success', data.responseMessage, 3000));
            }
            dispatch({ type: StakeMap.GET_GRAM_PRICE_ERROR });
            return dispatch(showSuccessSnackbar('error', data.responseMessage, 3000));
        } catch (error) {
            dispatch({ type: StakeMap.GET_GRAM_PRICE_ERROR });
            return dispatch(showSuccessSnackbar('error', "Error while updating price. Please try again later", 3000));
        }
    }
}


export const BuyGoldAction = {
    purchaseGoldStart: () => ({ type: StakeMap.PURCHASE_GOLD_START }),
    purchaseGoldSuccess: (data) => ({ type: StakeMap.PURCHASE_GOLD_SUCCESS, payload: data }),
    purchaseGoldError: () => ({ type: StakeMap.PURCHASE_GOLD_ERROR }),

    getAllPurchaseGoldOrderByIdStart: () => ({ type: StakeMap.GET_ALL_PURCHASE_GOLD_ORDER_BYID_START }),
    getAllPurchaseGoldOrderByIdSuccess: (data) => ({ type: StakeMap.GET_ALL_PURCHASE_GOLD_ORDER_BYID_SUCCESS, payload: data }),
    getAllPurchaseGoldOrderByIdError: () => ({ type: StakeMap.GET_ALL_PURCHASE_GOLD_ORDER_BYID_ERROR }),
}

export const buyPurchaseGoldAsync = (goldOrder, ercContract, address, cb) => {
    return async (dispatch, getState) => {
        try {
            let { _id } = getState().auth.user;
            dispatch(BuyGoldAction.purchaseGoldStart());
            let kycStatus = await ercContract.methods
                .getUserKycStatus(address)
                .call({ from: address });
            if (!kycStatus) {
                dispatch(BuyGoldAction.purchaseGoldError());
                return dispatch(showSuccessSnackbar('error', "KYC not done. Please contact admin.", defaultSnackbarTimeout));
            }
            const { data } = await axios({
                method: 'POST',
                url: `${authUrl}/purchase/${_id}`,
                headers: {
                    'Content-Type': 'application/json'
                },
                data: goldOrder
            })
            if (data.responseCode === 200) {
                dispatch(BuyGoldAction.purchaseGoldSuccess(data.responseData));
                dispatch(showSuccessSnackbar('success', data.responseMessage, defaultSnackbarTimeout));
                if(typeof cb === "function") {
                    cb();
                }
            } else {
                dispatch(BuyGoldAction.purchaseGoldError());
                dispatch(showSuccessSnackbar('error', data.responseMessage, defaultSnackbarTimeout));
            }
        } catch (error) {
            dispatch(BuyGoldAction.purchaseGoldError(error.message));
            dispatch(showSuccessSnackbar('error', error.message, defaultSnackbarTimeout));
        }
    }
}

export const getAllPurchaseGoldOrderByIdAsync = (batch, limit, status) => {
    return async (dispatch, getState) => {
        try {
            let { _id } = getState().auth.user;
            dispatch(BuyGoldAction.getAllPurchaseGoldOrderByIdStart());
            const { data } = await axios({
                method: 'POST',
                url: `${authUrl}/getAllPurchaseGoldOrderById/${_id}/${batch}/${limit}`,
                data: { status }
            })
            if (data.responseCode === 200) {
                let finalData = {
                    records: data.responseData.list,
                    totalRecords: data.responseData.total
                }
                dispatch(BuyGoldAction.getAllPurchaseGoldOrderByIdSuccess(finalData));
                // dispatch(showSuccessSnackbar('success', data.responseMessage, defaultSnackbarTimeout));
            } else {
                dispatch(BuyGoldAction.getAllPurchaseGoldOrderByIdError());
                dispatch(showSuccessSnackbar('error', data.responseMessage, defaultSnackbarTimeout));
            }
        } catch (error) {
            dispatch(BuyGoldAction.getAllPurchaseGoldOrderByIdError(error.message));
            dispatch(showSuccessSnackbar('error', error.message, defaultSnackbarTimeout));
        }
    }
}

export const setWithdrawRequestAsync = (goldOrder, cb) => {
    return async (dispatch, getState) => {
        try {
            let { _id } = getState().auth.user;
            dispatch({ type: StakeMap.SET_WITHDRAW_REQUEST_START });
            const { data } = await axios({
                method: 'POST',
                url: `${authUrl}/withdraw/${_id}`,
                headers: {
                    'Content-Type': 'application/json'
                },
                data: goldOrder
            })
            if (data.responseCode === 200) {
                if (typeof cb === "function") {
                    cb();
                }
                dispatch({ type: StakeMap.SET_WITHDRAW_REQUEST_SUCCESS, payload: data.responseData });
                dispatch(showSuccessSnackbar('success', data.responseMessage, defaultSnackbarTimeout));
            } else {
                dispatch({ type: StakeMap.SET_WITHDRAW_REQUEST_ERROR });
                dispatch(showSuccessSnackbar('error', data.responseMessage, defaultSnackbarTimeout));
            }
        } catch (error) {
            dispatch({ type: StakeMap.SET_WITHDRAW_REQUEST_ERROR });
            dispatch(showSuccessSnackbar('error', error.message, defaultSnackbarTimeout));
        }
    }
}

export const getWithdrawSettingsAsync = () => async (dispatch, getState) => {
    try {
        let { _id } = getState().auth.user;
        dispatch({ type: StakeMap.GET_WITHDRAW_SETTINGS_START });
        const { data } = await axios({
            method: "GET",
            url: `${authUrl}/getWithdrawSettings/${_id}/`,
        });
        console.log(data);
        if (data.responseCode === 200) {
            return dispatch({ type: StakeMap.GET_WITHDRAW_SETTINGS_SUCCESS, payload: data.responseData });
            // return dispatch(showSuccessSnackbar('success', data.responseMessage, 3000));
        }
        dispatch({ type: StakeMap.GET_WITHDRAW_SETTINGS_ERROR });
        return dispatch(showSuccessSnackbar('error', data.responseMessage, 3000));
    } catch (error) {
        dispatch({ type: StakeMap.GET_WITHDRAW_SETTINGS_ERROR });
        return dispatch(showSuccessSnackbar('error', "Error while getting configuration.", 3000));
    }
}

// export const getWithdrawReuestListAsync = () => {
//     return async (dispatch, getState) => {
//         try {
//             let { _id } = getState().auth.user;
//             dispatch({ type: StakeMap.GET_WITHDRAW_LIST_START });
//             const { data } = await axios({
//                 method: 'GET',
//                 url: `${authUrl}/getAllWithdraw/${_id}`,
//             })
//             if (data.responseCode === 200) {
//                 dispatch({ type: StakeMap.GET_WITHDRAW_LIST_SUCCESS, payload: data.responseData });
//                 dispatch(showSuccessSnackbar('success', data.responseMessage, defaultSnackbarTimeout));
//             } else {
//                 dispatch({ type: StakeMap.GET_WITHDRAW_LIST_ERROR });
//                 dispatch(showSuccessSnackbar('error', data.responseMessage, defaultSnackbarTimeout));
//             }
//         } catch (error) {
//             dispatch({ type: StakeMap.GET_WITHDRAW_LIST_ERROR });
//             dispatch(showSuccessSnackbar('error', error.message, defaultSnackbarTimeout));
//         }
//     }
// }